module.exports = __webpack_public_path__ + "60f12f643c38d4125e02b5934133a36d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/netflix_2021_chart.png
// module id = 1700
// module chunks = 0